import { Circle, Marker } from '@react-google-maps/api'
import { UseQueryResult } from '@tanstack/react-query'
import { TokenType } from '@vatom/sdk/core'
import { GeoDiscoveryGroup } from '@vatom/sdk/react'
import * as Location from 'expo-location'

import { getDistance } from '../../../utils/map'

import CustomMarker from './CustomMarker'
import GroupMarker from './GroupMarker'

export const createCustomMarkers = (
  filteredTokens: TokenType[],
  onMarkerClick: (item: TokenType) => void
) =>
  filteredTokens.map(item => (
    <CustomMarker key={`custom_marker_${item?.id}`} item={item} onMarkerClick={onMarkerClick} />
  ))

export const createGroupMarkers = (
  groups: GeoDiscoveryGroup[],
  onGroupMarkerPress: (geoGroup: GeoDiscoveryGroup) => void
) =>
  groups.map(item => (
    <GroupMarker key={`${item.key}-group-marker`} geoGroup={item} onPress={onGroupMarkerPress} />
  ))

export const createSingleMarkers = (
  singles: GeoDiscoveryGroup[],
  filteredTokens: TokenType[],
  onMarkerClick: (item: TokenType) => void
) =>
  singles
    .map(item => {
      const singleLocation = { lat: item.lat, lng: item.lon }
      const token = filteredTokens.find(
        token =>
          getDistance(singleLocation, {
            lat: token.position!.coordinates[1],
            lng: token.position!.coordinates[0]
          }) <= 1
      )
      return token
    })
    .filter(
      (value, index, self) => value && self.findIndex(item => item?.id === value?.id) === index
    )
    .map(token =>
      token ? (
        <CustomMarker
          key={`${token?.id}_custom_marker_with_groups`}
          item={token}
          onMarkerClick={onMarkerClick}
        />
      ) : null
    )

export const createUserLocationMarkers = (location?: Location.LocationObject) => [
  <Circle
    center={{ lat: location?.coords.latitude || 0, lng: location?.coords.longitude || 0 }}
    key={'userLocationAccuracyCircle'}
    radius={location?.coords.accuracy || 0}
    options={{
      fillColor: '#C8D6EC',
      strokeOpacity: 0,
      clickable: false
    }}
  />,
  <Marker
    position={{ lat: location?.coords.latitude || 0, lng: location?.coords.longitude || 0 }}
    key={'userLocation'}
    icon={{
      path: 0,
      fillColor: '#4285F4',
      fillOpacity: 1,
      scale: 8,
      strokeColor: 'white',
      strokeWeight: 2
    }}
  />
]
